// Mock data for Frachigers Handwerk – Armin Achermann
// Content sourced from frachigers-handwerk.ch

const FR = '/img/achermann';

export const COMPANY = {
  name: 'Frachigers Handwerk',
  shortName: 'AA+ Achermann',
  slogan: 'AA+ Qualität – Kundenmaurer & Plattenleger',
  subSlogan: 'Persönlich, zuverlässig und nah am Kunden',
  address: { street: 'Steckenmattstrasse 11', city: '6377 Seelisberg', full: 'Steckenmattstrasse 11, 6377 Seelisberg' },
  phone: '079 719 44 75',
  phoneInternational: '+41797194475',
  whatsapp: '41797194475',
  email: 'info@frachigers-handwerk.ch',
  website: 'www.frachigers-handwerk.ch',
  googleMaps: 'https://www.google.com/maps?q=Steckenmattstrasse+11,+6377+Seelisberg',
  googleReviews: 'https://www.google.com/search?q=Frachigers+Handwerk+Seelisberg',
  googleMapsEmbed: 'https://www.google.com/maps?q=Steckenmattstrasse%2011%2C%206377%20Seelisberg&output=embed',
  logo: 'https://customer-assets.emergentagent.com/job_kundenmaurer-pro/artifacts/hcu6xk1a_Logo___Achermann_Armin___LowRes.png',
  heroImage: `${FR}/imgi_9_gal01_platten_photo-2025-02-04-07-40-41.jpg`,
};

export const SERVICES = [
  { id: 'kundenmaurer', slug: 'kundenmaurer', icon: 'Hammer', image: `${FR}/imgi_6_PHOTO_2023_02_13_08_46_13.jpg` },
  { id: 'plattenleger', slug: 'plattenleger', icon: 'Layers', image: `${FR}/imgi_9_gal01_platten_photo-2025-02-04-07-40-41.jpg` },
  { id: 'hardrock', slug: 'hardrock', icon: 'Sparkles', image: 'https://images.unsplash.com/photo-1615873968403-89e068629265?auto=format&fit=crop&w=1600&q=80' },
  { id: 'abhof', slug: 'abhof', icon: 'Beef', image: `${FR}/imgi_31_Hof_PHOTO_2023_02_15_16_23_54.jpg` },
];

export const QUALITY_POINTS = [
  { id: '01', key: 'q1', icon: 'Award' },
  { id: '02', key: 'q2', icon: 'Briefcase' },
  { id: '03', key: 'q3', icon: 'Clock' },
  { id: '04', key: 'q4', icon: 'UserCheck' },
  { id: '05', key: 'q5', icon: 'BadgeCheck' },
  { id: '06', key: 'q6', icon: 'HeartHandshake' },
];

export const REFERENCES = [
  { id: 1, category: 'plattenleger', location: 'Seelisberg', image: `${FR}/imgi_9_gal01_platten_photo-2025-02-04-07-40-41.jpg`, titleKey: 'Plattenverlegung Nassraum' },
  { id: 2, category: 'plattenleger', location: 'Nidwalden', image: `${FR}/imgi_10_gal01_platten_photo-2025-02-04-07-40-42.jpg`, titleKey: 'Bodenplatten Wohnraum' },
  { id: 3, category: 'plattenleger', location: 'Obwalden', image: `${FR}/imgi_11_gal01_platten_photo-2025-02-04-07-40-43.jpg`, titleKey: 'Naturstein Badezimmer' },
  { id: 4, category: 'plattenleger', location: 'Luzern', image: `${FR}/imgi_12_gal01_platten_photo-2025-02-04-07-40-44.jpg`, titleKey: 'Fliesenboden Bad' },
  { id: 5, category: 'plattenleger', location: 'Uri', image: `${FR}/imgi_13_gal01_platten_photo-2025-02-04-07-40-45.jpg`, titleKey: 'Sitzplatz Terrasse' },
  { id: 6, category: 'plattenleger', location: 'Seelisberg', image: `${FR}/imgi_14_gal01_platten_photo-2025-02-04-07-41-59.jpg`, titleKey: 'Glasmosaik Detail' },
  { id: 7, category: 'plattenleger', location: 'Nidwalden', image: `${FR}/imgi_15_gal01_platten_photo-2025-02-04-07-41-60.jpg`, titleKey: 'Steinplatten Aussenbereich' },
  { id: 8, category: 'plattenleger', location: 'Obwalden', image: `${FR}/imgi_18_gal01_platten_photo-2025-02-20-20-58-40.jpg`, titleKey: 'Parkettverlegung' },
  { id: 9, category: 'plattenleger', location: 'Luzern', image: `${FR}/imgi_19_gal01_platten_photo-2025-02-20-20-58-41.jpg`, titleKey: 'Platten Wohnbereich' },
  { id: 10, category: 'plattenleger', location: 'Uri', image: `${FR}/imgi_20_gal01_platten_photo-2025-02-20-20-58-42.jpg`, titleKey: 'Bodenbelag Innen' },
  { id: 11, category: 'kundenmaurer', location: 'Seelisberg', image: `${FR}/imgi_6_PHOTO_2023_02_13_08_46_13.jpg`, titleKey: 'Bruchsteinmauer' },
  { id: 12, category: 'kundenmaurer', location: 'Uri', image: `${FR}/imgi_22_PHOTO_2023_02_13_08_50_48.jpg`, titleKey: 'Maurerarbeiten' },
  { id: 13, category: 'kundenmaurer', location: 'Nidwalden', image: `${FR}/imgi_3_PHOTO_2023_02_13_08_53_15.jpg`, titleKey: 'Verputzarbeiten' },
  { id: 14, category: 'kundenmaurer', location: 'Luzern', image: `${FR}/imgi_4_PHOTO_2023_02_13_08_53_58.jpg`, titleKey: 'Ausbesserungsarbeiten' },
  { id: 15, category: 'kundenmaurer', location: 'Seelisberg', image: `${FR}/imgi_23_PHOTO_2023_02_13_08_55_00.jpg`, titleKey: 'Pizzaofen Aussenbereich' },
  { id: 16, category: 'kundenmaurer', location: 'Obwalden', image: `${FR}/imgi_24_PHOTO_2023_02_13_08_58_49.jpg`, titleKey: 'Natursteinmauer Garten' },
  { id: 17, category: 'kundenmaurer', location: 'Uri', image: `${FR}/imgi_5_PHOTO_2023_02_13_09_00_20.jpg`, titleKey: 'Detailarbeit Mauerwerk' },
  { id: 18, category: 'kundenmaurer', location: 'Nidwalden', image: `${FR}/imgi_25_PHOTO_2023_02_13_09_03_14.jpg`, titleKey: 'Verputz Fassade' },
  { id: 19, category: 'kundenmaurer', location: 'Seelisberg', image: `${FR}/imgi_26_PHOTO_2023_02_13_09_05_23.jpg`, titleKey: 'Mauerdetail' },
  { id: 20, category: 'kundenmaurer', location: 'Luzern', image: `${FR}/imgi_27_PHOTO_2023_02_13_09_06_52.jpg`, titleKey: 'Mauerprojekt Zentralschweiz' },
  { id: 21, category: 'abhof', location: 'Seelisberg', image: `${FR}/imgi_31_Hof_PHOTO_2023_02_15_16_23_54.jpg`, titleKey: 'Unser Hof in Seelisberg' },
];

export const TEAM = [
  { id: 1, nameKey: 'Armin Achermann', roleKey: { de: 'Inhaber · Kundenmaurer & Plattenleger', en: 'Owner · Mason & Tiler', it: 'Titolare · Muratore & Piastrellista', fr: 'Propriétaire · Maçon & Carreleur' } },
];

export const TESTIMONIALS = [
  {
    nameKey: 'Familie Odermatt',
    roleKey: { de: 'Privatkunden · Seelisberg', en: 'Private clients · Seelisberg', it: 'Privati · Seelisberg', fr: 'Clients privés · Seelisberg' },
    textKey: {
      de: 'Armin hat unsere Bruchsteinmauer perfekt umgesetzt. Persönlich, zuverlässig und mit Herzblut. Wir empfehlen ihn jederzeit weiter.',
      en: 'Armin built our natural stone wall perfectly. Personal, reliable and with passion. We recommend him at any time.',
      it: 'Armin ha realizzato perfettamente il nostro muro in pietra. Personale, affidabile e con passione. Lo raccomandiamo sempre.',
      fr: 'Armin a réalisé parfaitement notre mur en pierre. Personnel, fiable et avec passion. Nous le recommandons à tout moment.',
    },
  },
  {
    nameKey: 'H. Bissig',
    roleKey: { de: 'Bauherr · Nidwalden', en: 'Builder · Nidwalden', it: 'Committente · Nidvaldo', fr: 'Maître d’ouvrage · Nidwald' },
    textKey: {
      de: 'Vom Plattenlegen im Bad bis zum Pizzaofen im Garten – Armin macht alles mit höchster Präzision. Faire Preise, top Ergebnis.',
      en: 'From tiling the bathroom to the pizza oven in the garden – Armin does everything with utmost precision. Fair prices, top results.',
      it: 'Dalla posa in bagno al forno per pizza in giardino – Armin fa tutto con massima precisione. Prezzi equi, risultati top.',
      fr: 'De la pose dans la salle de bain au four à pizza dans le jardin – Armin fait tout avec précision. Prix justes, top résultats.',
    },
  },
  {
    nameKey: 'R. Gisler',
    roleKey: { de: 'Landwirt · Uri', en: 'Farmer · Uri', it: 'Agricoltore · Uri', fr: 'Agriculteur · Uri' },
    textKey: {
      de: 'Als Einmannbetrieb hat Armin uns von der Beratung bis zur Fertigstellung persönlich betreut. So muss Handwerk sein.',
      en: 'As a one-man business, Armin looked after us personally from consultation to completion. That’s how craftsmanship should be.',
      it: 'Come impresa individuale, Armin ci ha seguito personalmente dalla consulenza al completamento. Così deve essere l’artigianato.',
      fr: 'En tant qu’entreprise individuelle, Armin nous a suivis personnellement du conseil à la finition. Voilà comment doit être l’artisanat.',
    },
  },
];
